const faqData = [
    {
        question: "What services does Stockport Solutions provide?",
        answer: "We offer integrated services across general trading, procurement, logistics consulting, cargo freight advisory, and e-commerce enablement. Our goal is to provide end-to-end solutions that simplify global commerce.",
    },
    {
        question: "Do you support small businesses and startups?",
        answer: "Yes. We work with companies of all sizes, including startups, offering affordable, flexible, and scalable solutions designed to grow with their business.",
    },
    {
        question: "How can I request a quotation or consultation?",
        answer: "You can contact us via our website, email, or phone. Our team will respond promptly with the required details or schedule a consultation.",
    },
    {
        question: "How do you ensure product quality?",
        answer: "All products undergo strict vendor evaluation, quality checks, and compliance verification to ensure they meet international standards before delivery.",
    },
    {
        question: "How can I request a quotation or consultation?",
        answer: "You can contact us via our website, email, or phone. Our team will respond promptly with the required details or schedule a consultation.",
    },
    {
        question: "Do you offer after-sales support?",
        answer: "Yes. We believe in long-term partnerships and provide continuous support, including product guidance, shipment tracking, and issue resolution.",
    },
    {
        question: "Why should I choose Stockport Solutions?",
        answer: "We combine quality, transparency, innovation, and reliability to deliver seamless solutions that help your business operate efficiently and grow sustainably.",
    },
];

export default faqData;
